/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for updating only the endpoint URL.
 * @export
 * @interface UpdateWebhookSettingsRequest
 */
export interface UpdateWebhookSettingsRequest {
    /**
     * The new endpoint URL for receiving webhooks. Pass null or an empty string to disable webhooks.
     * @type {string}
     * @memberof UpdateWebhookSettingsRequest
     */
    endpointUrl?: string | null;
}

/**
 * Check if a given object implements the UpdateWebhookSettingsRequest interface.
 */
export function instanceOfUpdateWebhookSettingsRequest(value: object): value is UpdateWebhookSettingsRequest {
    return true;
}

export function UpdateWebhookSettingsRequestFromJSON(json: any): UpdateWebhookSettingsRequest {
    return UpdateWebhookSettingsRequestFromJSONTyped(json, false);
}

export function UpdateWebhookSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWebhookSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endpointUrl': json['endpoint_url'] == null ? undefined : json['endpoint_url'],
    };
}

export function UpdateWebhookSettingsRequestToJSON(json: any): UpdateWebhookSettingsRequest {
    return UpdateWebhookSettingsRequestToJSONTyped(json, false);
}

export function UpdateWebhookSettingsRequestToJSONTyped(value?: UpdateWebhookSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint_url': value['endpointUrl'],
    };
}

